export default {
    install(Vue, options) {
        Vue.prototype.getDownPic = function (dataUrl) {
            let bytes=window.atob(dataUrl.split(',')[1]);        //去掉url的头，并转换为byte  
			let ab = new ArrayBuffer(bytes.length);  
			let ia = new Uint8Array(ab);  
			for (let i = 0; i < bytes.length; i++) {  
			    ia[i] = bytes.charCodeAt(i);  
			} 
			let formData = new FormData(); 
			let blob = new Blob( [ab] , {type : 'image/jpeg'});
            return blob;
        }
    }
} 
